import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Allowance: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0026 2H14.0026C14.3708 2 14.6693 2.29848 14.6693 2.66667V13.3333C14.6693 13.7015 14.3708 14 14.0026 14H2.0026C1.63442 14 1.33594 13.7015 1.33594 13.3333V2.66667C1.33594 2.29848 1.63442 2 2.0026 2ZM13.336 7.33333H2.66927V12.6667H13.336V7.33333ZM13.336 6V3.33333H2.66927V6H13.336ZM9.33595 10H12.0026V11.3333H9.33595V10Z"
        fill={color}
      />
    </svg>
  );
};

export default Allowance;
